import React from 'react';
import Inbound from '../components/Inbound';
import Outbound from '../components/Outbound';

export const nestedRoutes = [
  {
    path: 'inbound',
    component: <Inbound />,
  },
  {
    path: 'outbound',
    component: <Outbound />,
  },
];
